import { useLocalStorage } from "./useLocalStorage";

export const useSavedYear = (): { year: number; setYear: (value: number) => void } => {
  const { year, setYear } = useLocalStorage();
  return { year: year || new Date().getFullYear(), setYear };
};
